

//data-entry
export const DATA_ENTRY = "/my-work"
export const QA_REVIEW = "/qa-review"
export const EDIT_WORK = "/my-work/edit/"
export const SNIPPET = "/view-snippet"
export const NEW_DATA_ENTRY = "/new-grid"
export const NEW_QA_REVIEW = "/new-qa"
export const NEW_EDIT_WORK = "/new-edit-work/"
